import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Result } from 'antd';


const AccessDenied = () => {
  const navigate = useNavigate();
  const redirectTo = "/";

  return (
    <Result
    status="403"
    title="403"
    subTitle="Sorry, you are not authorized to access this page."
 
    extra={<Button type="primary" onClick={() => navigate(redirectTo)} >Back To HomePage</Button>}
  />
    
  );
};

export default AccessDenied;
